import React from 'react';
import { EmptyBlock } from '../../elements/EmptyBlock';

export const TeamEmpty = ({ minHeight }: { minHeight?: number | string }) =>
    <EmptyBlock
        minHeight={minHeight}
        title="You haven't created any custom templates yet."
        subtitle="When you do, they'll show up here."
    />;
